import { render } from "./DiscoverContent.vue?vue&type=template&id=0923a875"
import script from "./DiscoverContent.vue?vue&type=script&lang=js"
export * from "./DiscoverContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__